import { render, staticRenderFns } from "./AvanceCargarNotas.vue?vue&type=template&id=0cc591b4&"
import script from "./AvanceCargarNotas.vue?vue&type=script&lang=js&"
export * from "./AvanceCargarNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports